import { IDropdownSelect } from "types/gaiaComponents/dropdownButton";
import React, { useState, useEffect, useRef } from "react";
import { ChevronDownIcon, ChevronUpIcon, CircleXIcon } from "lucide-react";
import { DropdownList } from "components/common/dropdown/DropdownList.component";
import { ICON_SIZE, KEY } from "components/common/constants";
import { DropdownSelectTypes } from "types/gaiaComponents/dropdownButton.types";

export const DropdownSelect = (props: IDropdownSelect) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownOpen(false);
            }
        };

        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === KEY.ESCAPE) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [dropdownOpen]);

    const onClickDropdown = function (e: React.MouseEvent<HTMLDivElement>) {
        if (!props.disabled) {
            setDropdownOpen(!dropdownOpen);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if ((e.key === KEY.ENTER || e.key === KEY.SPACE) && !props.disabled) {
            e.preventDefault();
            setDropdownOpen(!dropdownOpen);
        }
    };

    return (
        <div ref={dropdownRef}
             className={`ga-native-select ga-select ${dropdownOpen? "ga-select--expanded":""} ${props.isEmpty? "ga-select--empty":""} ${props.isInvalid? "ga-select--invalid":""} ${props.disabled? "ga-select--disabled":""} ${props.isMulti? "ga-select--multi":""} ${props.extraClasses? props.extraClasses : ""}`}
             id={props.id}
             onClick={onClickDropdown}
             tabIndex={0}
             onKeyDown={handleKeyDown}>
            <div className="ga-select__main-area"
                 aria-haspopup="listbox"
                 aria-expanded={dropdownOpen}>
                {props.type === DropdownSelectTypes.VALUE &&
                    <div className="ga-select__value">{props.value}</div>
                }
                {props.type === DropdownSelectTypes.PLACEHOLDER &&
                    <div className="ga-select__placeholder">{props.placeholder}</div>
                }
                {props.type === DropdownSelectTypes.INPUT &&
                    <div className="ga-select__input">{props.input}</div>
                }
            </div>
            {dropdownOpen && !props.isEmpty &&
                <DropdownList items={props.items}
                              position={props.position}/>
            }
            <div className="ga-select__suffix">
                { dropdownOpen ?
                    <ChevronUpIcon className="ga-select__action-icon" size={ICON_SIZE.MEDIUM} /> :
                    <ChevronDownIcon className="ga-select__action-icon" size={ICON_SIZE.MEDIUM} />
                }
                {props.isClearable &&
                    <CircleXIcon size={ICON_SIZE.SMALL} className="ga-icon ga-select__action-icon" />
                }
            </div>
        </div>
    );
}